import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'card' | 'circle' | 'button';
}

export function Skeleton({ className, variant = 'text' }: SkeletonProps) {
  const baseClasses = 'animate-shimmer rounded';

  const variantClasses = {
    text: 'h-4 w-full',
    card: 'h-24 w-full',
    circle: 'h-12 w-12 rounded-full',
    button: 'h-10 w-32',
  };

  return (
    <div
      className={cn(
        baseClasses,
        variantClasses[variant],
        className
      )}
    />
  );
}

export function ProductCardSkeleton() {
  return (
    <div className="bg-dark-card rounded-lg p-4 border-2 border-gray-700">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2 flex-1">
          <Skeleton variant="circle" className="h-8 w-8" />
          <Skeleton className="h-5 w-32" />
        </div>
        <Skeleton className="h-6 w-16" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-2 w-full" />
        <div className="flex justify-between">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    </div>
  );
}

export function ProductListSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function RestockItemSkeleton() {
  return (
    <div className="flex justify-between items-start p-3 bg-dark-lighter rounded-lg border border-gray-700">
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-2">
          <Skeleton variant="circle" className="h-6 w-6" />
          <Skeleton className="h-4 w-40" />
        </div>
        <Skeleton className="h-3 w-32" />
      </div>
      <Skeleton className="h-6 w-16" />
    </div>
  );
}

export function RestockListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <RestockItemSkeleton key={i} />
      ))}
    </div>
  );
}
